import Button from '@mui/material/Button'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectMfaData } from '../../model/selectors/selectMfaData'
import { useEffect, useState } from 'react'
import { selectResendLoading } from '../../model/selectors/selectResendLoading'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { resendOtpCode } from '../../model/services/resendOtpCode'
import Box from '@mui/material/Box'
import { LAST_MFA_DATA } from '../../model/lib/consts'

export const ResendOtpBtn = () => {
	const dispatch = useAppDispatch()
	const resendLoading = useAppSelector(selectResendLoading)

	const mfaDataFromSS = JSON.parse(sessionStorage.getItem(LAST_MFA_DATA) || '')
	const mfaData = useAppSelector(selectMfaData) ?? mfaDataFromSS
	const mfaDataResendAfterSeconds = mfaData?.mfa.resendAfterSec || 60
	const [count, setCount] = useState(mfaDataResendAfterSeconds || 0)

	const handleClick = () => {
		dispatch(resendOtpCode({ challengeId: mfaData?.mfa.challengeId || '' }))
		setCount(Number(mfaDataResendAfterSeconds))
	}

	useEffect(() => {
		if (count > 0)
			setTimeout(() => {
				setCount(count - 1)
			}, 1000)
	})

	return (
		<Box>{
			count === 0 ? (
				<Box sx={{ color: '#7088AA' }}>
					<Button
						disableRipple
						disableElevation
						sx={{
							px: 0,
							font: 'inherit',
							color: 'inherit',
							boxShadow: 'none',
							textTransform: 'none',
							backgroundColor: 'transparent',
							'&:hover': { backgroundColor: 'transparent' },
							'&.MuiButtonBase-root:hover': { backgroundColor: 'transparent' },
							'&:active': { backgroundColor: 'transparent' },
							'&:focus': {
								backgroundColor: 'transparent',
								outline: 'none'
							},
							'&.Mui-focusVisible': { backgroundColor: 'transparent' }
						}}
						variant="text"
						size="small"
						onClick={handleClick}
					>
						Resend code
					</Button>
				</Box>
			) : (
				<Box sx={{ color: '#999999' }}>
					{resendLoading ? 'Sent ✓' : `Resend in ${count} seconds`}
				</Box>
			)
		}
		</Box>
	)
}